export default __webpack_public_path__ + "static/media/ASTHMA.327dc73d.png";